import { render } from "./ForeignTrade.vue?vue&type=template&id=98ebc2d0"
import script from "./ForeignTrade.vue?vue&type=script&lang=js"
export * from "./ForeignTrade.vue?vue&type=script&lang=js"

import "./ForeignTrade.vue?vue&type=style&index=0&id=98ebc2d0&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__